import React, {Component} from 'react';

export default class ParameterButton extends Component{
    render(){
        return(
            <div className="parameter-btn">
                <span>{this.props.text}</span>
                <div className="buttons">
                    <button type="button" 
                        className={'btn customer-style start '+(this.props.value===1?'selected':'')} 
                        onClick={() => this.props.onClick(this.props.id,1)}
                        title="Aktivierung erzwingen"
                    >On</button>
                    <button type="button" 
                        className={'btn customer-style middle '+(this.props.value===2?'selected':'')} 
                        onClick={() => this.props.onClick(this.props.id,2)}
                        title="Standardwert verwenden"
                    >Def</button>
                    <button type="button" 
                        className={'btn customer-style end '+(this.props.value===0?'selected':'')} 
                        onClick={() => this.props.onClick(this.props.id,0)}
                        title="Deaktivierung erzwingen"
                    >Off</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/overview/components/parameter-button.component.js